// extracted by mini-css-extract-plugin
export default {"notificationBox":"Header_notificationBox__3A2JN","bellBox":"Header_bellBox__FJg6V","bellAlert":"Header_bellAlert__gN-nU"};